import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'

export default {
	name: 'creategroup',
	components: {
		Paginate,
		Multiselect,
		VueElementLoading
	},
	data: function () {
		return {
			HubList: [],
			groupList: [],
			connectionList: [],
			Hubid: '',
			groupid: 0,
			pageno: 0,
			pageCount: 0,
			pageLimit: 10,
			resultCount: 0,
			totalRows: 0,
			showModal: false,
			popUpname: '',
			hubLoading: '',
			isLoading: false
		}
	},

	created: function () { },
	computed: {},

	mounted() {

		this.getCityList();
	},
	methods: {

		getGroupList() {
			if (typeof this.Hubid.value != 'undefined') {
				this.groupList = [];
				this.totalRows = 0
				this.isLoading = true;

				axios({
					method: 'GET',
					'url': apiUrl.api_url_hubops + 'getDestinationInformation?offset=' + this.pageno + '&limit=' + this.pageLimit + '&DestinationHubId=' + this.Hubid.value,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
					.then(result => {
						this.isLoading = false;
						if (result.data.ResultCode == 100) {
							this.groupList = result.data.ResponseData;
							this.resultCount = result.data.ResponseData.length;

							this.totalRows = result.data.TotalCount
							if (this.totalRows <= this.pageLimit) {
								this.pageCount = 1
							} else {
								this.pageCount = Math.ceil(this.totalRows / this.pageLimit);
							}
						} else {
							this.resultCount = 0;
							this.$alert(result.data.ReturnMessage, "", "error");
						}

					}, error => {
						this.isLoading = false;
						console.error(error)
					})
			} else {
				return false;
			}
		},

		getGroupConnections(data) {
			this.groupid = data.groupid;
			this.popUpname = data.groupname + ' - ' + data.routemode
			this.isLoading = true;

			axios({
				method: 'GET',
				// HUB-8340: replaces getConnectionsFromGroup (fields=default, activeOnly=true)
				//'url': apiUrl.api_url_hubops + 'getConnectionsByGroup?GroupId=' + this.groupid,
				'url': apiUrl.api_url_hubops + 'groups/' + this.groupid + '/connection-mappings?fields=default&activeOnly=true',
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
				.then(result => {
					this.isLoading = false;
					if (result.data.ResultCode == 100) {
						this.showModal = true;
						this.connectionList = result.data.ResponseData;
					} else {
						this.$alert(result.data.ReturnMessage, "", "error");
						return false;
					}
				}, error => {
					this.isLoading = false;
					console.error(error)
				})
		},

		closeModal() {
			this.showModal = false;
			$(document.body).removeClass("modal-open");
			$(".modal-backdrop").remove();
		},

		//to get City list
		getCityList() {
			this.hubLoading = 'Loading Hub...'
			var i = 0;
			this.resultCount = 0;
			this.input = ({})
			axios({
				method: 'POST',
				'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
				'data': this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
				.then(result => {
					this.hubLoading = ''
					var hubList = result.data.ResponseData
					for (i = 0; i < hubList.length; i++) {
						this.HubList.push({
							value: hubList[i].HubID,
							text: hubList[i].HubName + ' (' + hubList[i].HubID + ')'
						})
					}
				}, error => {
					this.hubLoading = ''
					console.error(error)
				})
		},

		resetForm() {
			this.Hubid = '';
			this.groupList = [];
			this.connectionList = [];
			this.groupid = 0;
			this.pageno = 0;
			this.pageCount = 0;
			this.resultCount = 0;
			this.totalRows = 0;
			this.showModal = false;
			this.popUpname = '';
			this.$validator.reset();
			this.errors.clear();
		},
		//to get pagination
		getPaginationData(pageNum) {
			this.pageno = (pageNum - 1)
			this.getGroupList();
		},

		//validate all form fields on onsubmit()
		onSubmit: function () {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				} else {
					this.getGroupList();
				}
			}).catch(() => {
				console.log('errors exist')
			});
		},

	}
}



// WEBPACK FOOTER //
// ./src/views/components/groupnew/DestinationSearch/DestinationSearch.js